export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑计划',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzPeriodStatus }) => !['N'].includes(amzPeriodStatus),
  },
  {
    text: that.$l('menu_text_change') || '计划变更',
    icon: 'el-icon-edit-outline',
    menuType: 'change',
    allow: 'C',
    disabled: ({ amzPeriodStatus }) => !['Y'].includes(amzPeriodStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除计划',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ amzPeriodStatus }) => !['N'].includes(amzPeriodStatus),
  },
  {
    text: that.$l('menu_text_enable') || '启用计划',
    icon: 'el-icon-video-play',
    menuType: 'enable',
    allow: 'E',
    disabled: ({ amzPeriodStatus }) => !['N'].includes(amzPeriodStatus),
  },
]
